import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown
} from 'reactstrap';

// Firebase
import { app } from '../../base';

class HeaderDropdown extends Component {

  constructor(props) {
    super(props);

    //this.logout = this.logout.bind(this);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  blank(){

  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  dropAccnt() {
    return (
      <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle nav>
          <img src={'img/avatars/6.png'} className="img-avatar" alt="Settings"/>
        </DropdownToggle>
        <DropdownMenu right>
          <Link to='/profile' className="link-dropdown"><DropdownItem><i className="fa fa-user"></i> Profile</DropdownItem></Link>
          <DropdownItem onClick={this.props.logout}><i className="fa fa-lock"></i> Logout</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }

  render() {
    const {...attributes} = this.props;
    return (
      this.dropAccnt()
    );
  }
}

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js